module.exports = __webpack_public_path__ + "img/ore_task_prjweb.964950a1.png";